import request from '@/utils/request'

// 角色权限配置：全部菜单 + 各角色当前勾选
export function getRoleMenuConfig() {
  return request({
    url: '/admin/role-menu/config',
    method: 'get'
  })
}

// 保存某角色的菜单
export function saveRoleMenu(data) {
  return request({
    url: '/admin/role-menu',
    method: 'post',
    data
  })
}

// 恢复某角色的默认菜单
export function resetRoleMenu(role) {
  return request({
    url: '/admin/role-menu/reset/' + role,
    method: 'post'
  })
}
